export const PROFILE_ACCEPTED_FILE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'bmp',
  'webp',
];

export const UPLOAD_STATES = {
  CONFIRMATION: 'confirmation',
  EDIT: 'edit',
  INITIAL: 'initial',
  PREVIEW: 'preview',
};

export const ACCEPTED_IMAGE_TYPES = [
  '.jpg',
  '.jpeg',
  '.png',
  '.bmp',
  '.webp',
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/webp',
];

const MAX_FILE_SIZE_MB = 5;
const MIN_FILE_SIZE_KB = 10;
export const INVALID_FILE_TYPE_MESSAGE =
  'We only accept jpg, jpeg, png, bmp or webp files.';
export const FILE_SIZE_INVALID_MESSAGE = `Upload a file that is between ${MIN_FILE_SIZE_KB} KB and ${MAX_FILE_SIZE_MB} MB in size.`;

export const FILE_SIZE_INVALID_MESSAGE_AFTER_EDIT =
  'The selected image area is too small to save. Please go back and select a larger area or upload a bigger file.';

export const CIRCLE_DIAMETER = 185;

export const INITIAL_SCALE = 1;
export const INITIAL_POSITION = { x: 0.5, y: 0.5 };
export const MIN_FILE_SIZE_BYTES = 10240;
export const MAX_FILE_SIZE_BYTES = 5242880;
export const AVATAR_DELETE_CONFIRMATION_MODAL_TITLE = 'Delete photo';
export const AVATAR_DELETE_WARNING_MESSAGE =
  "Are you sure you want to delete your photo? Once deleted, the current photo can't be recovered.";
export const GENERIC_API_FAILURE_MESSAGE =
  "We're sorry, we were unable to save your changes. Please try again.";

export const USER_STATUSES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};
